module.exports = __webpack_public_path__ + "static/media/VanessaGreen.7c5a5de9.png";